import { NgModule } from '@angular/core';
import { AtajosTecladoDirective } from './atajos-teclado.directive';
import { BackgroundHoverDirective } from './background-hover.directive';
import { CalendarReadOnlyDirective } from './calendar-read-only.directive';
import { CurrentcolorDirective } from './current-color.directive';
import { DecimalsDirective } from './decimals.directive';
import { DigitOnlyDotDirective } from './digit-dot-only.directive';
import { DigitOnlyDirective } from './digit-only.directive';
import { InputDecimalsDirective } from './input-decimals.directive';
import { InputDigitOnlyDirective } from './input-digit-only.directive';
import { InputRegexDirective } from './input-regex.directive';
import { InputRestrictDirective } from './input-restrict.directive';
import { NumericNegativeDirective } from './numeric-negative';
import { MenuCloseDirective } from './menu-close.directive';
import { NumericDirective } from './numeric.directive';
import { UppercaseDirective } from './uppercase.directive';
import { AppFocusDirective } from './element-focus.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { BlacklistInputDirective } from './blacklist-input.directive';

@NgModule({
    declarations: [
        CurrentcolorDirective,
        DigitOnlyDirective,
        InputRegexDirective,
        BackgroundHoverDirective,
        CalendarReadOnlyDirective,
        InputRestrictDirective,
        InputDecimalsDirective,
        InputDigitOnlyDirective,
        UppercaseDirective,
        DecimalsDirective,
        AtajosTecladoDirective,
        NumericDirective,
        DigitOnlyDotDirective,
        MenuCloseDirective,
        NumericNegativeDirective,
        AppFocusDirective,
        ClickOutsideDirective,
        BlacklistInputDirective
    ],
    exports: [
        CurrentcolorDirective,
        DigitOnlyDirective,
        InputRegexDirective,
        BackgroundHoverDirective,
        CalendarReadOnlyDirective,
        InputRestrictDirective,
        InputDecimalsDirective,
        InputDigitOnlyDirective,
        UppercaseDirective,
        DecimalsDirective,
        AtajosTecladoDirective,
        NumericDirective,
        MenuCloseDirective,
        NumericNegativeDirective,
        DigitOnlyDotDirective,
        AppFocusDirective,
        ClickOutsideDirective,
        BlacklistInputDirective
    ]
})
export class DirectivesModule { }
